<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useNotification } from "@kyvg/vue3-notification"
import FormButton from '../Atoms/FormButton.vue';
import SubscriptionService from '@/services/SubscriptionService';
import { track, EVENTS } from '@/lib/tracking'

const props = defineProps({
	streamType: {
		type: String,
		required: false
	}
})

const store = useStore()

const error = ref(null)

const isLoading = ref(false)
const { notify } = useNotification()	

const emit = defineEmits(['close-sidebar'])

const closeSidebar = () => {
	emit('close-sidebar')
}

const activateTrial = async () => {
	try {
		isLoading.value = true
		await SubscriptionService.requestTrial(props.streamType || 'live');
		// update vuex state
		await store.dispatch('User/loadUser', true, { root: true });
		notify({
			group: 'success',
			text: `${props.streamType === 'scheduled' ? 'Pre-recorded Stream' : 'Live Stream'} trial activated successfully`
		});
		track(EVENTS.TRIAL_STARTED, {
			packCategory: props.streamType || 'live',
		})
	} catch (e) {
		error.value = e;
		return;
	} finally {
		isLoading.value = false
		closeSidebar();
	}
}
</script>

<template>
	<section>
		<div class="bg-surface-3 !p-4 my-6 rounded-md">
			<p class="font-medium text-surface-text-1">Start your free 7-day trial</p>
			<p class="text-sm text-surface-8 mt-1">Try Live Streaming free for 7 days. Create streams and go live on
				any platform. No commitment.</p>
		</div>
		<div class="!px-4">
			<div class="flex flex-col gap-2">
				<FormButton :isLoading="isLoading" class="w-full text-center justify-center" label="Activate free trial"
					@click="activateTrial" />
				<FormButton class="w-full text-center justify-center" type="secondary" label="Close"
					@click="closeSidebar" />
			</div>
			<FormButton class="w-full text-center justify-center !mt-4" type="link" to="/subscribe?category=live">
				See all plans
			</FormButton>
		</div>
	</section>
</template>
